<template>
    <label>{{ $e('Choose WordPress post') }}</label>
    <RichSelect
        v-if="trigger.settings"
        v-model="trigger.settings.page_id"
        modelValue="trigger.settings.page_id"
        :settings="{ ajax: { url: this.restUrl('flow/posts'), dataType: 'json' } }"
        :ajaxUrl="restUrl('flow/pages')"
        :placeholder="'Select page'"
        @select="pageSelected"
    >
        <option :value="trigger.settings.page_id" selected :key="trigger.settings.page_id" v-if="trigger.settings && trigger.settings.page_id">
            {{ trigger.settings.page_title ? trigger.settings.page_title : trigger.settings.page_id }}
        </option>
    </RichSelect>
</template>

<script>
import RichSelect from "../../Global/RichSelect.vue"

export default {
    components: { RichSelect },
    props: {
        trigger:  { type: Object, required: true }
    },
    methods: {
        /**
         * Update the selected text
         */
        pageSelected(selected) {
            this.trigger.settings.page_title = selected.text
        },
    }
}
</script>
